<template>
    <div class="majorDetail_home">
        <div class="md1">
            <div class="md1_cont">
                <div class="md1_title">
                    <div class="cn">{{ majorData.cname }}</div>
                    <div class="en">{{ majorData.ename | upperCase }}</div>
                </div>
                <div class="md1_main">
                    <img :src="'https://public.rossoarts.com/static/uploads/' + majorData.image" alt="" class="md1_left">
                    <div class="md1_right">
                        <div class="md1_right_title">
                            <div class="md1_right_item" @click="toggleMd1(0)">专业描述</div>
                            <div class="md1_right_item" @click="toggleMd1(1)">就业前景</div>
                        </div>
                        <div class="md1_right_cont_box">
                                <div class="md1_right_cont">
                                    {{ majorData.introduction }}


                                </div>
                                <div class="md1_right_cont">
                                    {{ majorData.prospect }}
                                </div>
                            <div class="md1_right_btn_box">
                                <a href="javascript:void(0)" class="md1_right_btn" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })">
                                    <img src="../img/Group 456.png" alt="">
                                    <p>立即咨询</p>
                                </a>
                                <a href="javascript:void(0)" class="md1_right_btn" @click="coverInp()">

                                    <img src="../img/Group 577.png" alt="">
                                    <p>获取专业解读</p>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="md2">
            <div class="section_title">
                <p class="section_cn">课程推荐</p>
                <p class="section_en">RECOMMENDED PROJECTS</p>
            </div>
            <div class="md2_cont">
                <div class="c2_item">
                    <div class="c2_tuoyuan"></div>
                    <div class="c2_blue_line"></div>
                    <div class="c2_title c2_title1">
                        <div>VIP院校保送计划</div>
                    </div>
                    <p class="c2_p2">适合人群：</p>
                    <p class="c2_p3">申请艺术设计院校本科、研究生的学生</p>
                    <div class="c2_img_box">
                        <img src="../img/艺术课程/Rectangle 155.jpg" alt="" class="c2_img">
                        <img src="../img/艺术课程/Group 339.png" alt="" class="c2_icon">
                        <div class="c2_hid_box">
                            <ul>
                                <li><span></span>定制化全套作品集课程</li>
                                <li><span></span>海外教授多V1辅导</li>
                                <li><span></span>欧美权威专业TOP3、TOP5、TOP8名校OFFER</li>
                                <li><span></span>梦校直通车</li>
                            </ul>
                            <div class="kefu_btn">
                                <a  @click="jopCourseDetail('PortfolioInfo/vip.html')" style="cursor: pointer;"> 

                                    <p>课程详情</p>
                                    <img src="../img/Group 578.png" alt="">
                                </a>
                                <a href="javascript:void(0)" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })">

                                    <p class="p2">预约试听</p>
                                    <img src="../img/Frame.png" alt="">
                                </a>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="c2_item">
                    <div class="c2_tuoyuan"></div>
                    <div class="c2_blue_line"></div>
                    <div class="c2_title c2_title1">
                        <div>专业作品集辅导</div>
                    </div>
                    <p class="c2_p2">适合人群：</p>
                    <p class="c2_p3">已具备基础课能力的学生，计划申请艺术设计院校本科、研究生</p>
                    <div class="c2_img_box">
                        <img src="../img/艺术课程/Rectangle 156.jpg" alt="" class="c2_img">
                        <img src="../img/艺术课程/Group 339.png" alt="" class="c2_icon">
                        <div class="c2_hid_box">
                            <ul>
                                <li><span></span>多名艺术导师量身制定作品集产出</li>
                                <li><span></span>海外高等院校教学模式</li>
                                <li><span></span>四级教学法+五维审核体系</li>
                                <li><span></span>多元化竞赛资源</li>
                            </ul>
                            <div class="kefu_btn">
                                <a @click="jopCourseDetail('PortfolioInfo/sample.html')" style="cursor: pointer;">

                                    <p>课程详情</p>
                                    <img src="../img/Group 578.png" alt="">
                                </a>
                                <a href="javascript:void(0)" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })">

                                    <p class="p2">预约试听</p>
                                    <img src="../img/Frame.png" alt="">
                                </a>
                            </div>
                        </div>
                    </div>

                </div>
                <img src="../img/艺术课程/0.png" alt="" class="pos_img1">
                <img src="../img/艺术课程/Mask group.png" alt="" class="pos_img2">
            </div>
        </div>
        <div class="md3">
            <div class="section_title">
                <p class="section_cn">院校推荐</p>
                <p class="section_en">RECOMMENDED SCHOOLS</p>
            </div>
            <div class="md3_cont">
                <div class="md3_left">
                    <div class="md3_cont_title">
                        <div class="md3_title_item" @click="toggleCountry(0)">英国</div>
                        <div class="md3_title_item" @click="toggleCountry(1)">美国</div>
                        <div class="md3_title_item" @click="toggleCountry(2)">其他</div>
                    </div>
                    <div class="md3_item_box">
                        <div class="s3_item" v-for="(item, index) in theFourSchool"  @click="schoolDetail(item.id,item.cname)">
                            <div class="s3_item_left">
                                <div>
                                    <div class="s3_item_imgbox">
                                        <img :src="'https://public.rossoarts.com/static/uploads/' + item.logo" alt="">
                                        <p class="s3_title_cn">{{ item.cname }}</p>
                                        <p class="s3_title_en">{{ item.ename }}</p>
                                    </div>
                                    <div class="s3_pBox" style="margin-top: 10px;">
                                        <p class="s3_pTtitle">申请难度：</p>
                                        <el-rate v-model="rateValue" disabled text-color="#ff9900" :colors="colors"
                                            score-template="{value}">
                                        </el-rate>
                                    </div>
                                    <div class="s3_pBox">
                                        <p class="s3_pTtitle">学费：</p>
                                        <div>{{ item.tuition }}</div>
                                    </div>
                                    <div class="s3_pBox">
                                        <p class="s3_pTtitle">语言成绩：</p>
                                        <div >雅思: 6.0｜托福:N/A｜SAT:N/A</div>
                                    </div>
                                    <div class="s3_pBox">
                                        <p class="s3_pTtitle">申请截止：</p>
                                        <div class="s3_pBox_language">{{ item.off_date }}</div>
                                    </div>
                                    <div class="s3_pBox">
                                        <p class="s3_p_major">
                                            <span class="s3_pTtitle">专业推荐：</span>{{ item.mj }}
                                        </p>
                                        <!-- <p></p> -->
                                    </div>
                                </div>
                                <div class="itemMore_box">
                                    <div class="itemMore">
                                        <img src="../img/院校搜索/Group 152.png" alt="">
                                        <p>了解更多</p>
                                    </div>
                                    <a href="javascript:void(0)" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })" class="itemMore_add"
                                        @click="jopkefu($event)">

                                        <img src="../img/院校搜索/Group 456.png" alt="">
                                        <p>即刻咨询</p>

                                    </a>

                                </div>
                            </div>
                            <div class="s3_item_right">
                                <img :src="'https://public.rossoarts.com/static/uploads/' + item.school_img_small" alt="">
                                <div class="top_div">
                                    <p class="en">{{ item.admission_num }}</p>
                                    <p class="item_mei">枚</p>
                                </div>
                            </div>
                        </div>
                        <div class="s3_more" @click="getmoreSchool()">
                            <div>查看更多</div>
                            <div class="s3_more_line1"></div>
                            <div class="s3_more_line2"></div>
                        </div>
                    </div>
                </div>
                <a href="javascript:void(0)" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })">
                    <div class="md3_right">
                        <img src="../img/Group 618.jpg" alt="" class="md3_right_main">
                        <div class="md3_right_bottom">
                            <p>了解更多</p>
                            <img src="../img/Group 619.png" alt="" class="md3_right_icon">
                        </div>
                    </div>
                </a>
            </div>
        </div>

        <div class="section_inp school4">
            <div class="s_inp_left">
                <img src="../img/shouchahua.png" alt="" class="img_shou animated wow rotateInDownLeft" id="imgShou">
                <img src="../img/Group 2404.png" alt="" class="img_text animated wow rollIn" id="imgText">
            </div>
            <div class="s_inp_right">
                <el-form :inline="true" :label-position="labelPosition" label-width="150px" :model="formLabelAlign">
                    <el-form-item label="姓名：">
                        <el-input v-model="formLabelAlign.name" placeholder="请输入姓名"></el-input>
                    </el-form-item>
                  

                    <el-form-item label="意向国家：" class="elitem2" >
                        <el-select v-model="formLabelAlign.region2" placeholder="选择意向国家" >
                            <el-option label="英国" value="England"></el-option>
                            <el-option label="美国" value="America"></el-option>
                            <el-option label="日本" value="Japan"></el-option>
                            <el-option label="新加坡" value="Singapore"></el-option>
                            <el-option label="韩国" value="Korea"></el-option>
                            <el-option label="欧洲" value="Europe"></el-option>
                          
                            <el-option label="其他" value="Other"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="电话：">
                        <el-input v-model="formLabelAlign.tel" placeholder="请输入电话号码"></el-input>
                    </el-form-item>
                    <el-form-item label="留学预算：">
                        <el-input v-model="formLabelAlign.budget" placeholder="请输入您的预算"></el-input>
                    </el-form-item>
                    <el-form-item class="yuyue_box">
                        <div class="yuyue" @click="onSubmit()"></div>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>
<script>
import "@/assets/css/majordetail.css"
import axios from "axios"
export default {
    data() {
        return {
            majorData: [],
            schoolArr: [],
            theSchool: [],
            theFourSchool: [],
            colors: ['#99A9BF', '#FB6333', '#FF9900'],
            rateValue: 3.5,
            schoolArrIndex: 0,
            labelPosition: 'right',
            formLabelAlign: {
                name: '',
                tel: '',
                region: '',
                region2: '',
                budget: '',
            },

        }
    },
    filters: {
        upperCase(val) {
            if (val) {
                return val.toUpperCase()
            }
        }
    },
    created() {
        // console.log(this.$route.params.id.split(".")[0]);
        this.getMajorsId(this.$route.params.id.split(".")[0])

    },

    methods: {
        jopCourseDetail(val){
            this.$router.push(`/${val}`)
        },
        schoolDetail(val,val2) {
            // window.open(`https://public.rossoarts.com/schools/${val}.html`, "_blank")
            // this.$router.push(`/schools/${val}.html`)
            // this.$router.push(`/schools/${val}.html`)

            this.$router.push({
              
                path:  `/schools/${val}.html?cname=${val2}`,
              
            })
        },
        coverInp() {
            var coverBlack2 = document.getElementById("coverBlack2")
            coverBlack2.style.display = "block"

        },
        scrollForm() {
            var section_inp = document.getElementsByClassName("section_inp")
            var m2_item_left = document.getElementsByClassName("m2_item_left")
            section_inp[0].scrollIntoView({
                block: 'end',
                behavior: 'smooth',

            })
        },
        onSubmit() {
            var currentURL = window.location.href;
            var status = ''
            // 检查 URL 中是否包含某些关键词，来判断使用的搜索引擎
            if (currentURL.includes("google")) {
                status = "用户正在使用 Google 搜索引擎"
            } else if (currentURL.includes("bing")) {
                status = "用户正在使用 Bing 搜索引擎"
            } else if (currentURL.includes("yahoo")) {
                status = "用户正在使用 Yahoo 搜索引擎"
            } else if (currentURL.includes("baidu")) {
                status = "用户正在使用 百度 搜索引擎"
            } else {
                status = "无法确定用户使用的搜索引擎"
            }
            // console.log('submit!',this.formInline);
            var patt = /^1[3-9][0-9]{9}$/

            if (this.formLabelAlign.name == "" || this.formLabelAlign.tel == "") {
                // console.log("姓名和手机号不能为空");
                this.$message.error('姓名和手机号不能为空');

            } else {
                // console.log("不是空");

                if (patt.test(this.formLabelAlign.tel)) {

                    // console.log("可以发请求");
                    // console.log(this.formInline);
                    axios.post("https://public.rossoarts.com/index/common/getform", {
                        "name": this.formLabelAlign.name,
                        "tel": this.formLabelAlign.tel,
                        "budget": this.formLabelAlign.budget,
                        "url": window.location.href,
                        "status":status,
                    }).then((data) => {
                        console.log(data, "response");
                        this.$message({
                            message: '提交成功',
                            type: 'success'
                        });
                    }).catch(function (error) {
                        console.log(error, "error");
                    });

                } else {
                    console.log("手机号格式不正确");
                    this.$message.error('手机号格式不正确');

                }

            }


        },
        enterSubmit() {
            if (event.keyCode == 13) {
                this.searchSchool()
            }
        },
        getmoreSchool() {
            var s3_more = document.getElementsByClassName("s3_more")
            this.schoolArrIndex++;
            this.theFourSchool = this.theSchool.slice(0, this.schoolArrIndex * 4 + 4)

            if (this.theSchool.length < (this.schoolArrIndex + 1) * 4 || this.theSchool.length == (this.schoolArrIndex + 1) * 4) {
                s3_more[0].style.display = "none"

            }else{
                s3_more[0].style.display = "flex"

            }
        },
        coverSchool() {
           
            var s3_more = document.getElementsByClassName("s3_more")
            if (this.theSchool.length > 4) {
                this.theFourSchool = this.theSchool.slice(0, this.schoolArrIndex + 4)
                s3_more[0].style.display = "flex"
                // console.log(this.theSchool.length,"flex");
            } else {
                // console.log(this.theSchool.length,"none");
                s3_more[0].style.display = "none"
            }
        },
        toggleCountry(val) {
            this.schoolArrIndex = 0;
            var md3_title_item = document.getElementsByClassName("md3_title_item")
            for (var i = 0; i < md3_title_item.length; i++) {

                md3_title_item[i].style.backgroundColor = "#fff"
            }
            md3_title_item[val].style.backgroundColor = "#5F9DF7"
            this.theSchool = this.schoolArr[val]
            this.theFourSchool = this.theSchool.slice(0, 4)

            this.coverSchool()
            
        },
        toggleMd1(val) {
            console.log(val);
            var md1_right_item = document.getElementsByClassName("md1_right_item")
            var md1_right_cont = document.getElementsByClassName("md1_right_cont")
            for (var i = 0; i < md1_right_item.length; i++) {
                md1_right_item[i].style.borderBottomColor = "rgba(0,0,0,0.4)"
                md1_right_item[i].style.color = "rgba(0,0,0,0.4)"
                md1_right_cont[i].style.display = "none"
            }
            md1_right_item[val].style.borderBottomColor = "rgba(0,0,0,1)"
            md1_right_item[val].style.color = "rgba(0,0,0,1)"
            md1_right_cont[val].style.display = "block"
        },
        getMajorsId(val) {
            axios.get(`https://public.rossoarts.com/api/v1/getContentMajor?id=${val}`).then((data) => {
                // console.log(data.data.data);
                this.majorData = data.data.data

                // this.theSchoolData =  this.majorData.uk_school_sort
                this.schoolArr.push(data.data.data.uk_school_sort)
                this.schoolArr.push(data.data.data.usa_school_sort)
                this.schoolArr.push(data.data.data.other_school_sort)
                console.log(this.schoolArr);
                this.theSchool = this.schoolArr[0]
                this.theFourSchool = this.schoolArr[0].slice(0, 4)
                this.$nextTick(() => {
                    this.coverSchool()
                })
            })
        },


    },

}
</script>